const MAP = {
  Ontime: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Terlambat: "bg-rose-50 text-rose-700 border-rose-200",
  "Pulang Cepat": "bg-amber-50 text-amber-800 border-amber-200",
  Cuti: "bg-blue-50 text-blue-700 border-blue-200",
  Izin: "bg-sky-50 text-sky-700 border-sky-200",
  Sakit: "bg-orange-50 text-orange-700 border-orange-200",
  Alpha: "bg-slate-100 text-slate-700 border-slate-300",
  "Dinas Luar": "bg-purple-50 text-purple-700 border-purple-200",
  "Tugas Luar": "bg-violet-50 text-violet-700 border-violet-200",
  "Istirahat Haid": "bg-pink-50 text-pink-700 border-pink-200",
  "Istirahat Melahirkan / Gugur Kandungan": "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  Menunggu: "bg-amber-50 text-amber-800 border-amber-200",
  Disetujui: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Ditolak: "bg-rose-50 text-rose-700 border-rose-200",
  // SPPD status
  "Menunggu Approval Atasan": "bg-amber-50 text-amber-800 border-amber-200",
  "Menunggu Approval Penandatangan ST": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Surat Tugas Terbit": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Ditolak Atasan": "bg-rose-50 text-rose-700 border-rose-200",
  "Ditolak Penandatangan": "bg-rose-50 text-rose-700 border-rose-200",
};

export function StatusBadge({ status, size = "md", testId }) {
  if (!status) return <span className="text-xs text-slate-400">—</span>;
  const cls = MAP[status] || "bg-slate-100 text-slate-700 border-slate-300";
  const sz = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full border font-semibold ${cls} ${sz}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}

export default StatusBadge;
